import { render, staticRenderFns } from "./select-book-training.vue?vue&type=template&id=10f79711"
import script from "./select-book-training.vue?vue&type=script&lang=js"
export * from "./select-book-training.vue?vue&type=script&lang=js"
import style0 from "./select-book-training.vue?vue&type=style&index=0&id=10f79711&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports